import React, { useState, useEffect, useCallback } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdOutlineRestaurantMenu } from "react-icons/md";

import images from "../../constants/images";
import "./Navbar.css";

const DOORDASH_URL =
  "https://www.doordash.com/store/pho-ha-long-san-antonio-41685551/103535348/?aw=hEV_jbHuzoPHt7HK";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeAllMenu = () => {
    setToggleMenu(false);
    setSubMenuOpen(false);
  };

  const toggleSubMenu = (e) => {
    e.preventDefault();
    setSubMenuOpen(!subMenuOpen);
  };

  // Handle menu tab switching from navbar links
  const handleMenuNavClick = useCallback((e, categoryId) => {
    e.preventDefault();
    closeAllMenu();

    // Dispatch custom event to switch menu tab
    window.dispatchEvent(
      new CustomEvent("switchMenuTab", { detail: { category: categoryId } })
    );

    // Scroll to menu section
    const menuEl = document.getElementById("menu");
    if (menuEl) {
      const navHeight = 80;
      const top = menuEl.getBoundingClientRect().top + window.scrollY - navHeight;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }, []);

  return (
    <nav className={`app__navbar ${scrolled ? "app__navbar--scrolled" : ""}`}>
      <div className="app__navbar-logo">
        <a href="#home">
          <img src={images.phohalong} alt="Pho Ha Long logo" />
        </a>
      </div>
      <ul className="app__navbar-links">
        <li className="p__opensans">
          <a href="#home">Home</a>
        </li>
        <li className="p__opensans app__navbar-menu-dropdown-item">
          <a href="#menu">Menu</a>
          <ul className="app__navbar-dropdown">
            <li className="p__opensans">
              <a href="#pho" onClick={(e) => handleMenuNavClick(e, "pho")}>
                Pho
              </a>
            </li>
            <li className="p__opensans">
              <a
                href="#appetizer"
                onClick={(e) => handleMenuNavClick(e, "appetizer")}
              >
                Appetizer
              </a>
            </li>
            <li className="p__opensans">
              <a
                href="#vermicelli"
                onClick={(e) => handleMenuNavClick(e, "vermicelli")}
              >
                Vermicelli or Rice
              </a>
            </li>
            <li className="p__opensans">
              <a
                href="#lomein"
                onClick={(e) => handleMenuNavClick(e, "lomein")}
              >
                Lo Mein
              </a>
            </li>
            <li className="p__opensans">
              <a
                href="#rice_and_noodle"
                onClick={(e) => handleMenuNavClick(e, "rice_and_noodle")}
              >
                Rice & Noodle
              </a>
            </li>
            <li className="p__opensans">
              <a href="#kids" onClick={(e) => handleMenuNavClick(e, "kids")}>
                Kids Meal
              </a>
            </li>
            <li className="p__opensans">
              <a
                href="#beverages"
                onClick={(e) => handleMenuNavClick(e, "beverages")}
              >
                Beverages
              </a>
            </li>
            <li className="p__opensans">
              <a href="#boba" onClick={(e) => handleMenuNavClick(e, "boba")}>
                Boba Tea
              </a>
            </li>
          </ul>
        </li>
        <li className="p__opensans">
          <a href="#contact">Find Us</a>
        </li>
      </ul>

      <a
        href={DOORDASH_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="app__navbar-order-btn"
      >
        Order Delivery
      </a>

      <div className="app__navbar-smallscreen">
        <GiHamburgerMenu
          color="#fff"
          fontSize={27}
          onClick={() => setToggleMenu(true)}
        />

        {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
            <MdOutlineRestaurantMenu
              fontSize={27}
              className="overlay__close"
              onClick={() => setToggleMenu(false)}
            />
            <ul className="app__navbar-smallscreen_links">
              <li className="p__opensans">
                <a href="#home" onClick={closeAllMenu}>
                  Home
                </a>
              </li>
              <li className="p__opensans">
                <a
                  href="#menu"
                  onClick={toggleSubMenu}
                  aria-expanded={subMenuOpen}
                  aria-controls={"smallscreen-submenu"}
                >
                  Menu
                </a>
                {subMenuOpen && (
                  <ul className="app__navbar-smallscreen-submenu">
                    <li className="p__opensans">
                      <a
                        href="#pho"
                        onClick={(e) => handleMenuNavClick(e, "pho")}
                      >
                        Pho
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a
                        href="#appetizer"
                        onClick={(e) => handleMenuNavClick(e, "appetizer")}
                      >
                        Appetizer
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a
                        href="#vermicelli"
                        onClick={(e) => handleMenuNavClick(e, "vermicelli")}
                      >
                        Vermicelli or Rice
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a
                        href="#lomein"
                        onClick={(e) => handleMenuNavClick(e, "lomein")}
                      >
                        Lo Mein
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a
                        href="#rice_and_noodle"
                        onClick={(e) =>
                          handleMenuNavClick(e, "rice_and_noodle")
                        }
                      >
                        Rice & Noodle
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a
                        href="#kids"
                        onClick={(e) => handleMenuNavClick(e, "kids")}
                      >
                        Kids Meal
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a
                        href="#beverages"
                        onClick={(e) => handleMenuNavClick(e, "beverages")}
                      >
                        Beverages
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a
                        href="#boba"
                        onClick={(e) => handleMenuNavClick(e, "boba")}
                      >
                        Boba Tea
                      </a>
                    </li>
                  </ul>
                )}
              </li>
              <li className="p__opensans">
                <a href="#contact" onClick={closeAllMenu}>
                  Find Us
                </a>
              </li>
              <li>
                <a
                  href={DOORDASH_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app__navbar-order-btn app__navbar-order-btn--mobile"
                  onClick={closeAllMenu}
                >
                  Order Delivery
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
